import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/spacecraft.svg'


const _hoisted_1 = {
  class: "contact",
  "aria-label": "Kontaktmöglichkeit"
}
const _hoisted_2 = { class: "data-privacy" }
const _hoisted_3 = { for: "accept-terms-checkbox" }
const _hoisted_4 = ["checked"]

import { ref, watch } from 'vue';
import { useToast } from 'vue-toastification';
import config from '@/config.json';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailComponent',
  props: {
    overlayIsVisible: { type: Boolean }
  },
  emits: ["setIsLoading", "toggleOverlay"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const checkboxRef = ref(null);

watch (props, (value) => {
  if (!value.overlayIsVisible && checkboxRef.value) {
    (checkboxRef.value as HTMLElement).focus();
  }
});

const email = ref('');
const checked = ref(false);
const submitted = ref(false);

const isValid = () => {
  const regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return email.value && email.value.match(regEx) && checked.value;
};

const onSubmit = async () => {
  const toast = useToast();

  submitted.value = true;

  if (!isValid()) {
    toast.error('Bitte gib eine gültige E-Mail-Adresse ein und akzeptiere die Bedingungen zum Datenschutz.', {
      id: 'notValid',
    });

    return;
  }

  emit('setIsLoading', true);

  toast.dismiss('notValid');

  await sendEmail(email.value);

  onReset();
  emit('setIsLoading', false);
};

const sendEmail = async (address: string) => {
  const toast = useToast();

  if (!config.sendEmail) {
    toast.success('Vielen Dank, du hörst demnächst von uns! 🙂', {
      id: 'isValid',
    });

    return;
  }

  const requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      ctx: 'quiz',
      email: address,
      to: config.sendEmailTo
    }),
  };

  try {
    await fetch(config.sendEmailUrl, requestOptions)
        .then(response => response.json())
        .then(response => {
          if (response === 'success') {
            toast.success('Vielen Dank, du hörst demnächst von uns! 🙂', {
              id: 'isValid',
            });
          } else {
            toast.error('Oops, da ist wohl etwas schief gelaufen. Bitte versuche es später noch einmal.', {
              id: 'error',
            });
          }
        });
  } catch (exception) {
    console.error(exception);
    toast.error('Oops, da ist wohl etwas schief gelaufen. Bitte versuche es später noch einmal.', {
      id: 'error',
    });
  }
};

const onReset = () => {
  email.value = '';
  checked.value = false;
  submitted.value = false;
};

const onToggleCheckbox = () => {
  checked.value = !checked.value;
};

const onToggleOverlay = () => {
  emit('toggleOverlay', true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      autocomplete: "off",
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Fragen zum Projekt?", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("p", null, "Hinterlasse uns gerne deine E-Mail-Adresse. Wir melden uns dann bei dir.", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        placeholder: "Deine E-Mail-Adresse..."
      }, null, 512), [
        [_vModelText, email.value]
      ]),
      _createElementVNode("p", _hoisted_2, [
        _createElementVNode("span", null, [
          _cache[3] || (_cache[3] = _createTextVNode("Ich akzeptiere die Bestimmungen zum ")),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onToggleOverlay()), ["stop"])),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (onToggleOverlay()), ["enter","space"])),
            role: "button",
            tabIndex: "0"
          }, " Datenschutz", 32),
          _cache[4] || (_cache[4] = _createTextVNode(". "))
        ]),
        _createElementVNode("label", _hoisted_3, [
          _createElementVNode("input", {
            ref_key: "checkboxRef",
            ref: checkboxRef,
            id: "accept-terms-checkbox",
            type: "checkbox",
            value: "1",
            checked: checked.value,
            onClick: _withModifiers(onToggleCheckbox, ["stop"])
          }, null, 8, _hoisted_4)
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("button", { type: "submit" }, "Abschicken", -1)),
      (email.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "reset",
            onClick: onReset,
            onKeyup: _withKeys(onReset, ["enter","space"]),
            role: "button",
            tabIndex: "0"
          }, " × Löschen ", 32))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}
}

})